type TrafficFine = {
  description: string;
  value: number;
  _id: string;
};

type InfoTrafficFines = {
  paymentIds: string[];
  licensePlate: string;
  autoNumbers: string[];
  totalFine: number;
};

export function extractPaymentDescription(description: string) {
  // Captura a placa: letras, dígitos e hífens
  const plateRegex = /PLACA:\s*([A-Z0-9-]+)/i;
  // Captura tudo que vem após "AUTO DE INFRAÇÃO Nº:" até o primeiro sinal de "+" ou fim da string
  const autoRegex = /AUTO DE INFRAÇÃO Nº:\s*([^+]+)/i;

  const plateMatch = description.match(plateRegex);
  const autoMatch = description.match(autoRegex);

  const licensePlate = plateMatch ? plateMatch[1].trim() : null;
  let autoNumbers: string[] = [];

  if (autoMatch) {
    // Divide a string capturada por espaços, vírgulas ou barras
    autoNumbers = autoMatch[1]
      .trim()
      .split(/[\s,]+/)
      .filter((num) => num.length > 0);
  }

  return { licensePlate, autoNumbers };
}

export function groupFinesByPlate(trafficFines: TrafficFine[]): InfoTrafficFines[] {
  // Cria um objeto para agrupar as multas por placa.
  const grouped: Record<string, { autoNumbers: Set<string>; totalFine: number; paymentIds: string[] }> = {};

  trafficFines.forEach((fine) => {
    // Extrai a placa e os números dos autos
    const { licensePlate, autoNumbers } = extractPaymentDescription(fine.description);
    // Converte o valor para número (você pode usar sua função de unmask, por exemplo)
    const fineValue = fine.value;
    
    if (licensePlate) {
      if (!grouped[licensePlate]) {
        grouped[licensePlate] = { autoNumbers: new Set(), totalFine: 0, paymentIds: [] };
      }
      autoNumbers.forEach((num) => grouped[licensePlate].autoNumbers.add(num));
      grouped[licensePlate].totalFine += isNaN(fineValue) ? 0 : fineValue;
      grouped[licensePlate].paymentIds.push(fine._id);
    }
  });

  // Converte o objeto agrupado para um array
  const result = Object.entries(grouped).map(([licensePlate, { autoNumbers, totalFine, paymentIds }]) => ({
    paymentIds,
    licensePlate,
    autoNumbers: Array.from(autoNumbers),
    totalFine,
  }) as InfoTrafficFines);

  return result;
}